// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__36F87","rootSmall":"AddTileButton_rootSmall__2MfPj"};